import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: '5digit'
})
export class FiveDigitRandomNumberPipe {
    constructor() {
        this.generateNumber();

    }
    generateNumber() {
        // 5digit number
            // return Math.floor(Math.random() * 90000) + 10000;
        // 5 digit alphanumeric number
            // return Math.random().toString(36).substr(2, 5);
        // or
            var chars = "23456789ABCDEFGHJKMNPQRSTUVWXTZabcdefghkmnpqrstuvwxyz";
            var string_length = 5;
            var randomstring = '';
            for (var i = 0; i < string_length; i++) {
                var rnum = Math.floor(Math.random() * chars.length);
                randomstring += chars.substring(rnum, rnum + 1);
            }
            return randomstring;
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/randomNumber.pipe.ts